var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.stepNumber == 0 ? "block" : "hidden" }, [
    _c("h1", { staticClass: "registration-form-layout__title" }, [
      _vm._v(_vm._s(_vm.subscriptionsFormTitle))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "registration-form registration-form-layout flex" },
      [
        _c("h3", { staticClass: "registration-form-layout__block-title" }, [
          _vm._v(_vm._s(_vm.businessTitle))
        ]),
        _vm._v(" "),
        _c("theme-input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "`required`"
            }
          ],
          attrs: {
            label: _vm.companyName,
            name: _vm.companyNameInput,
            isRequired: true,
            placeholder: _vm.companyNamePlaceholder
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "grid grid-cols-1 gap-x-4 gap-y-5 md:grid-cols-2 md:gap-y-7"
          },
          [
            _c("theme-input", {
              attrs: {
                label:
                  (_vm.locales &&
                    _vm.locales.subscriptions &&
                    _vm.locales.subscriptions.contact_person + " ") +
                  _vm.subscriptionsFirstName,
                name: _vm.subscriptionsFirstNameInput,
                placeholder: _vm.subscriptionsFirstNamePlaceholder
              }
            }),
            _vm._v(" "),
            _c("theme-input", {
              attrs: {
                label:
                  (_vm.locales &&
                    _vm.locales.subscriptions &&
                    _vm.locales.subscriptions.contact_person + " ") +
                  _vm.subscriptionsMiddleName,
                name: _vm.subscriptionsMiddleNameInput,
                placeholder: _vm.subscriptionsMiddleNamePlaceholder
              }
            }),
            _vm._v(" "),
            _c("theme-input", {
              attrs: {
                label:
                  (_vm.locales &&
                    _vm.locales.subscriptions &&
                    _vm.locales.subscriptions.contact_person + " ") +
                  _vm.subscriptionsLastName,
                name: _vm.subscriptionsLastNameInput,
                placeholder: _vm.subscriptionsLastNamePlaceholder
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "grid grid-cols-1 gap-x-4 gap-y-5 md:grid-cols-2 md:gap-y-7"
          },
          [
            _c("theme-input", {
              attrs: {
                label: _vm.companyChamberOfCommerceNumber,
                name: _vm.companyChamberOfCommerceNumberInput,
                placeholder: _vm.companyChamberOfCommerceNumberPlaceholder
              }
            }),
            _vm._v(" "),
            _c("theme-input", {
              attrs: {
                label: _vm.companyVatNumber,
                name: _vm.companyVatNumberInput,
                placeholder: _vm.companyVatNumberPlaceholder
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("theme-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|phone_number",
                  expression: "`required|phone_number`"
                }
              ],
              staticClass: "js-unique-phone",
              attrs: {
                label: _vm.companyPhoneNumber,
                name: _vm.companyPhoneNumberInput,
                placeholder: _vm.companyPhoneNumberPlaceholder,
                isRequired: true
              },
              on: { blur: _vm.checkPhone }
            }),
            _vm._v(" "),
            !!_vm.is_phone_number_unique
              ? _c("div", { staticClass: "mt-2" }, [
                  _c("span", { staticClass: "text-[#FF695B] text-[12px]" }, [
                    _vm._v(_vm._s(_vm.phoneNumberAlreadyExists))
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "`required`"
                      }
                    ],
                    attrs: { type: "hidden", name: "phone_number_unique" }
                  })
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("theme-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|email",
                  expression: "`required|email`"
                }
              ],
              staticClass: "js-unique-mail",
              attrs: {
                label: _vm.companyEmail,
                name: _vm.companyEmailInput,
                placeholder: _vm.companyEmailPlaceholder,
                isRequired: true
              },
              on: { blur: _vm.checkMail }
            }),
            _vm._v(" "),
            _vm.is_user_already_exists == 1
              ? _c("div", { staticClass: "mt-2" }, [
                  _c("span", { staticClass: "text-[#FF695B] text-[12px]" }, [
                    _vm._v(_vm._s(_vm.isUserAlreadyExists))
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "`required`"
                      }
                    ],
                    attrs: { type: "hidden", name: "user_already_exists" }
                  })
                ])
              : _vm.is_user_already_exists == 2
              ? _c("div", { staticClass: "mt-2" }, [
                  _c("span", { staticClass: "text-[#FF695B] text-[12px]" }, [
                    _vm._v(_vm._s(_vm.isUserBanned))
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "`required`"
                      }
                    ],
                    attrs: { type: "hidden", name: "user_already_exists" }
                  })
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("theme-input", {
          attrs: {
            label: _vm.companyInvoiceEmail,
            name: _vm.companyInvoiceEmailInput,
            placeholder: _vm.companyInvoiceEmailPlaceholder
          }
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass:
              "theme-btn theme-btn--theme theme-btn--block bg-[#2EC3FF]",
            attrs: { id: "submitFormBtn", type: "submit" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.submitForm.apply(null, arguments)
              }
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.commonCreateAccount) + "\n    ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41f21cdd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41f21cdd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/RegistrationFormSH.vue
// module id = 662
// module chunks = 1